<template>
  <section class="section --center">
    <div class="section__content">
      <p v-if="content.header" class="text__accent section__accent">{{ content.header }}</p>
      <h2>{{ content.title }}</h2>
      <p class="paragraph mt-16">{{ content.description }}</p>
      <DynamicLink :button="content.button" :link="link" :page="page" class="mt-30" />
    </div>
  </section>
</template>

<script>
import DynamicLink from '@/components/small/DynamicLink.vue'

export default {
  name: 'CTASection',
  components: { DynamicLink },
  props: {
    content: {
      type: Object,
      required: true,
    },
    link: {
      type: String,
      default: '',
    },
    page: {
      type: String,
      default: '',
    },
  },
}
</script>
